import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { IGetItemsWithTokenParams } from '../../../../httpClient/serverApi/types/IGetItemsWithTokenParams';
import { IServerUser } from '../types/IServerUser';

export interface IGetServerUsersWithTokenParams extends IGetItemsWithTokenParams {
}

export interface IGetServerUsersWithTokenResult extends IGetItemsResult {
  users: IServerUser[];
}

export class GetServerUsersWithTokenRequest extends Request<IGetServerUsersWithTokenParams, IGetServerUsersWithTokenResult> {
  constructor(params: IGetServerUsersWithTokenParams = {}) {
    super('getServerUsersWithToken', params);
  }
}